import { z } from "zod";
import moment, { Moment } from "moment";

export const momentSchema = z.custom<Moment>((val) => moment.isMoment(val));
